/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeeditor_Read_Only_ModeInputs */



/**
* | output |
* | --- |
* | "Read-only mode" |
*
* @param {Spaces_Codeeditor_Read_Only_ModeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeeditor_read_only_mode = /** @type {((inputs?: Spaces_Codeeditor_Read_Only_ModeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeeditor_Read_Only_ModeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur-Lese-Modus")
	return /** @type {LocalizedString} */ ("Read-only mode")
});